// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CodelistValue
 */
export interface CodelistValue {
    /**
     * 
     * @type {string}
     * @memberof CodelistValue
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof CodelistValue
     */
    decode?: string;
    /**
     * 
     * @type {string}
     * @memberof CodelistValue
     */
    other_value?: string;
}

/**
 * Check if a given object implements the CodelistValue interface.
 */
export function instanceOfCodelistValue(value: object): value is CodelistValue {
    if (!('code' in value) || value['code'] === undefined) return false;
    return true;
}

export function CodelistValueFromJSON(json: any): CodelistValue {
    return CodelistValueFromJSONTyped(json, false);
}

export function CodelistValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): CodelistValue {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'decode': json['decode'] == null ? undefined : json['decode'],
        'other_value': json['other_value'] == null ? undefined : json['other_value'],
    };
}

export function CodelistValueToJSON(json: any): CodelistValue {
    return CodelistValueToJSONTyped(json, false);
}

export function CodelistValueToJSONTyped(value?: CodelistValue | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'decode': value['decode'],
        'other_value': value['other_value'],
    };
}
